// extracted by mini-css-extract-plugin
export default {"claretTitleStyles":"Content_claretTitleStyles__MxHzm","whiteTextStyles":"Content_whiteTextStyles__wPPy4","greySecondaryText":"Content_greySecondaryText__4ycne"};